import { ChangeEvent, FormEvent, useState } from "react";
import FrameBack from "../../images/frame_back.svg?react";
import MainLogo from "./../../images/main-logo.svg?react";
import UserIcon from "./../../images/person.svg?react";
import TextField from "@material-ui/core/TextField";
import TalaeraSpinner from "../../components/TalaeraSpinner/TalaeraSpinner";
import { signInSSO } from "../../services/users/auth";
import { TalaeraError } from "services/errors";
import { getErrorComponents } from "../../services/util";
import styles from "./SignInSSO.module.scss";
import { Link, useSearchParams } from "react-router-dom";
import { routes } from "pages/routes";
import { useTranslation } from "react-i18next";
import { trackEvent } from "services/productAnalytics";

export default function SignInSSO() {
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState(searchParams.get("email") || "");
  const [error, setError] = useState<TalaeraError | null>(searchParams.get("error"));
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const onSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setError(null);
    setLoading(true);

    try {
      const response = await signInSSO(email);
      window.location.replace(response.redirect_url);
      trackEvent("sign_in_success");
    } catch (err) {
      setError(err as TalaeraError);
      trackEvent("sign_in_error", { error: err });
    } finally {
      setLoading(false);
    }
  };

  const onEmailChange = (event: ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();
    setEmail(event.target.value);
  };

  return (
    <div className={styles.page}>
      <div className={styles.content}>
        <MainLogo />
        <div className={styles.header}>
          <UserIcon />
          <h1>{t("Signin.ssoTitle")}</h1>
        </div>
        {loading && (
          <div className={styles.spinner}>
            <TalaeraSpinner />
          </div>
        )}
        {error && getErrorComponents(error)}
        <form onSubmit={onSubmit}>
          <div className={styles.formWrapper}>
            <TextField
              disabled={loading}
              name="email"
              label={t("Signin.ssoEmailLabel")}
              placeholder="johnsmith@gmail.com"
              variant="outlined"
              value={email}
              onChange={onEmailChange}
            />
            <button disabled={loading} className={styles.button} type="submit">
              {t("Signin.ssoSignin")}
            </button>
            <Link className={styles.link} to={routes.public.signIn.path()} replace>
              {t("Signin.ssoBackToSignIn")}
            </Link>
          </div>
        </form>
      </div>
      <FrameBack className={styles.frameBack} />
    </div>
  );
}
